import { Actions } from 'vuex-smart-module';
import RepairsGetters from './getters';
import RepairsMutations from './mutations';
import RepairsState from './state';

export default class RepairsActions extends Actions<
RepairsState,
RepairsGetters,
RepairsMutations,
RepairsActions
> {}
